import * as React from "react";
import Button from "../core/Button";
import Card from "../core/Card";
import Modal from "../core/Modal";
import Select from "react-select";
import { toast } from "../../utils";
import {
  getUserSubordinates,
  normalizeUser,
  saveUserRecord,
} from "../../libs/user";
import EmployeeList from "./EmployeeList";

interface Props {
  availableUsers: IJsonApiResponse<IUserRecord[]>;
  manager: IJsonApiResponse<IUserRecord>;
}

interface State {
  open: boolean;
  userToManage: ISelectOption | null;
  manager: IUser;
  managedUsers: IUser[];
}

class EmployeeManagerList extends React.Component<Props, State> {
  state: State = {
    open: false,
    userToManage: null,
    manager: normalizeUser(this.props.manager.data),
    managedUsers: [],
  };

  componentDidMount() {
    this.fetchSubordinates();
  }

  async fetchSubordinates() {
    const managedUsers = await getUserSubordinates(this.state.manager.id);
    this.setState({ managedUsers });
  }

  addManagedUser = () => {
    const { userToManage, manager } = this.state;
    const { availableUsers } = this.props;

    if (!userToManage) {
      return;
    }

    const user = availableUsers.data.find(u => u.id === userToManage.value);

    if (!user) {
      toast.error(`Error adding manager to user.`);
      return;
    }

    user!.attributes.managerId = Number(manager.id);

    saveUserRecord(user)
      .then(() => {
        this.fetchSubordinates();
        this.setState({ open: false });
        toast.success(
          `${manager.name} is now the manager of ${user.attributes.name}`
        );
      })
      .catch(() => toast.error("An error occurred while saving the user."));
  };

  render() {
    const { userToManage, manager } = this.state;

    const availableUserOpts = this.props.availableUsers.data.map(u => ({
      label: u.attributes.name,
      value: u.id,
    }));

    return (
      <Card title="Managed Users">
        <EmployeeList employees={this.state.managedUsers} showRoles={true} />
        <Button onClick={() => this.setState({ open: true })}>
          Add Managed User
        </Button>
        <Modal
          title="Add User to Manager"
          open={this.state.open}
          close={() => this.setState({ open: false })}
          onSubmit={this.addManagedUser}
        >
          <Select
            options={availableUserOpts}
            value={userToManage || undefined}
            onChange={opt =>
              this.setState({ userToManage: opt as ISelectOption })
            }
          />
        </Modal>
      </Card>
    );
  }
}

export default EmployeeManagerList;



// WEBPACK FOOTER //
// ./app/javascript/components/employee/EmployeeManagerList.tsx